"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.table = void 0;

var _stylitas = require("@creditas/stylitas");

const table = ({
  theme,
  fullWidth
}) => (0, _stylitas.css)`
  width: ${fullWidth ? '100%' : 'auto'};
  background-color: ${theme.bColorneutal00};
  color: ${theme.bColorneutral07};
  font-size: 16px;
  font-family: ${theme.bTextsupportFontFamily};
`;

exports.table = table;